import appConfig from '@/config';

import { useCreateMSWClient } from './useCreateMSWClient';

const { createMSWClient } = useCreateMSWClient();

// muncher
const { client: crossbeamApi, setCustomHeader } = createMSWClient(
  appConfig.apiBaseUrl,
);

// mcp
const { client: agentApi } = createMSWClient(appConfig.agentBaseUrl);

export { crossbeamApi, agentApi, setCustomHeader };
